import { GET_MY_NOTIFICATIONS } from '@/shared/api/rtkApi';
import type { AppDispatch } from '@/shared/config/storeConfig';
import { myNotificationsApi } from '../api/myNotificationsApi';

export const handleNotificationsUnreadCountUpdated = (dispatch: AppDispatch, count: number) => {
  dispatch(
    myNotificationsApi.util.upsertQueryData('getMyNotificationsUnreadCount', undefined, { count }),
  );
};

export const handleNotificationNew = (dispatch: AppDispatch) => {
  dispatch(myNotificationsApi.util.invalidateTags([GET_MY_NOTIFICATIONS]));
};
